<template>
    <template v-if="mode === 'table'">
        <div v-if="modelValue">
            <div v-if="v<=20">{{options[v-1].title}}</div>
            <div v-else>{{ v }}</div>
        </div>
        <div v-else>
            <div></div>
        </div>

<!-- как-то криво - надо разобраться -->
<!-- {{ options[v].title }} -->
    </template>

    <template v-else-if="mode === 'view'">
        <div v-if="modelValue">
            <div v-if="v<=20">{{options[v-1].title}}</div>
            <div v-else>{{ v }}</div>
        </div>
        <div v-else>
            <div></div>
        </div>
    </template>
    
    <template v-else-if="mode === 'edit'">
        <!-- {{ options }} -->

                <v-select
                variant="outlined"
                v-model="select"
                    :items="options"
                    item-title="title"
                    item-value="value"
                    :label=column.title
                    return-object
                    @update:modelValue="handleInput"
                    hide-details="auto"
                    class="mb-1"
                ></v-select>

<!--                    @update:modelValue="handleInput"-->
          <!--select v-model="selected">
    <option v-for="option in options" :key="option.id" :value="option.value">
      {{ option.text }}
    </option>
  </select-->
  
    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<script>
export default {
    name: 'select-widget',
    props:['mode','column','modelValue'],
    emits: ['update:modelValue'],
    data(){

//        console.log(this.column.widget.properties.options)
let options=[];

let list=this.column.widget.properties.options.split(';');

    list.map(function (value){
        let val=value.split(':');
        let item={"value":val[0], "title": val[1]}

        options.push(item);

        // let list=this.column.widget.properties.options.split(';')
        // list.map(function (value){
        //     let val=value.split(':');
        //     options[val[0]]=val[1];
        })

        return {
        //    v: this.modelValue,
        //    options: options,

           v: this.modelValue,
      options: options,

      cvalue: null,
      select: { title: 'All', value: '' },
   //   select: { title: options[1].title, value: options[1].value },

        } 
    },   
    methods:{
        // handleInput (e) {            
        //    this.v = e.target.value;
        handleInput () {  
        this.v = this.select.value;           
           this.$emit('update:modelValue', this.v);
        },
    },

    watch: {
        modelValue() {
            this.v = this.modelValue;
        }
    },
}
</script>